import { HealthInfoResponse } from 'src/types/health.types';
import { sfetchJson } from '../internals/sfetch';

export const getHealthInfo = async (connectionString: string): Promise<HealthInfoResponse> => {
  return await sfetchJson(`${connectionString}/health`)
    .then((healthStatus) => {
      return healthStatus;
    })
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw 'not_found';
      }
      if (error instanceof TypeError) {
        throw 'network_problem';
      }
      throw error;
    });
};
